module.exports = __webpack_public_path__ + "media/images/country-flags-europe-flag-united-kingdom-uk-7e78677e7b9907c83d9fe9e8ffb98fe1.svg";